import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout, message } from 'antd';
import Login from './components/Login';
import AdminDashboard from './AdminDashboard';
import EmployeeDashboard from './components/EmployeeDashboard';
import DatabaseManager from './utils/DatabaseManager';
import './App.css';

const { Header, Content } = Layout;

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    initializeApp();
  }, []);

  const initializeApp = async () => {
    try {
      await DatabaseManager.initialize();
      const savedUser = localStorage.getItem('user');
      if (savedUser) {
        setUser(JSON.parse(savedUser));
      }
    } catch (error) {
      message.error('Error al inicializar la aplicación: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleLogin = (userData) => {
    setUser(userData);
    localStorage.setItem('user', JSON.stringify(userData));
  };

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem('user');
  };

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <div>Cargando...</div>
      </div>
    );
  }

  return (
    <Layout style={{ minHeight: '100vh' }}>
      {user && (
        <Header style={{ background: '#001529', padding: '0 20px' }}>
          <div style={{ color: 'white', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h1 style={{ margin: 0, fontSize: '20px' }}>
              Simulador de Comisiones RCN
            </h1>
            <div>
              <span style={{ marginRight: '20px' }}>
                {user.nombre} ({user.role === 'admin' ? 'Administrador' : 'Ejecutivo'})
              </span>
              <button 
                onClick={handleLogout}
                style={{ background: 'red', color: 'white', border: 'none', padding: '5px 15px', borderRadius: '4px', cursor: 'pointer' }}
              >
                Cerrar Sesión
              </button>
            </div>
          </div>
        </Header>
      )}
      
      <Content style={{ padding: user ? '20px' : '0', margin: '0', minHeight: 'calc(100vh - 64px)' }}>
        <Routes>
          <Route 
            path="/" 
            element={user ? (
              user.role === 'admin' ? 
                <Navigate to="/admin" replace /> : 
                <Navigate to="/employee" replace />
            ) : (
              <Login onLogin={handleLogin} />
            )} 
          />
          <Route 
            path="/admin" 
            element={user && user.role === 'admin' ? 
              <AdminDashboard user={user} /> : 
              <Navigate to="/" replace />} 
          />
          <Route 
            path="/employee" 
            element={user && (user.role === 'employee' || user.role === 'user') ? 
              <EmployeeDashboard user={user} /> : 
              <Navigate to="/" replace />} 
          />
        </Routes>
      </Content>
    </Layout>
  );
}

export default App;